<div *ngIf="loading && (!filteredItems || filteredItems.length <= 0)" class="progress mt-10">
  <div
    class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
    role="progressbar"
    aria-valuenow="75"
    aria-valuemin="0"
    aria-valuemax="100"
    style="width: 75%"
  ></div>
</div>
<div class="filter-list">
  <div class="filter-list-wrapper">
    <ng-container *ngTemplateOutlet="topFilter ? upFilter : sideFilter"></ng-container>
    <div class="row" *ngIf="selectionActions">
      <lib-selection-bar
        [selectionActions]="selectionActions"
        [filteredItems]="filteredItems"
        [allItems]="items"
        (barHeight)="adjustBottomMargin($event)"
      ></lib-selection-bar>
    </div>
  </div>
</div>

<div (click)="toggleFilters()" [ngClass]="shouldDisplayOverlay ? 'overlay-visible' : 'overlay-hidden'"></div>

<ng-template #sideFilter>
  <div class="row" [hidden]="loading && (!filteredItems || filteredItems.length <= 0)" [ngStyle]="containerStyles">
    <div
      #gungFilters
      [ngClass]="getGungFilterClasses()"
      [class]="getFilterGroupCss()"
      class="col-12 sticky gung-filters d-flex flex-column"
    >
      <div class="gung-filters-inner d-flex flex-column">
        <lib-filter-list-side-filter
          *ngFor="let renderFilter of renderFilters"
          [renderFilter]="renderFilter"
          (selectValue)="setSelection(renderFilter.name, $event, true)"
          (deselectValue)="setSelection(renderFilter.name, $event, false)"
          (selectValueRange)="setSelection(renderFilter.name, null, true, $event)"
        ></lib-filter-list-side-filter>
        <lib-selected-filter
          [renderFilters]="renderFiltersForSelected"
          (deselectAll)="clearSelection()"
          (deselectValue)="setSelection($event.filterName, $event.valueId, false)"
          (deselectValueRange)="setSelection($event.filterName, null, false, $event.valueIdRange)"
        >
        </lib-selected-filter>
      </div>
    </div>
    <div
      [ngClass]="{
        'col-12 col-lg-9': renderFilters && renderFilters.length > 0,
        'col-12': renderFilters && renderFilters.length === 0
      }"
      class="col-12"
    >
      <div class="product-list-search-group">
        <div class="row" [ngClass]="getSearchGroupCss()">
          <div class="mb-2 col-md col-12">
            <div class="search-title">{{ 'REGUMMERANDE_DACK' | translate }}</div>
            1
            <lib-filter-list-search
              (searchUpdated)="setSearch($event)"
              [placeholder]="getSearchPlaceholderTranslate()"
              [initSearchTerm]="searchTerm"
            >
            </lib-filter-list-search>
            <p class="mr-3" *ngIf="items">
              {{
                'PRODUCT_LIST_TOTAL'
                  | translate: { limit: (renderItems | async).length, total: filteredItems.length || items.length }
              }}
            </p>
          </div>
          <div class="col col-md-3" *ngIf="batchSizes && batchSizes.length > 1">
            <lib-filter-list-batch (batchSizeUpdated)="setBatchSize($event)" [batchSizes]="batchSizes">
            </lib-filter-list-batch>
          </div>
          <div class="col-auto" *ngIf="layouts && layouts.length > 1">
            <button
              class="btn"
              *ngFor="let layout of layouts; let layoutIndex = index"
              (click)="changeLayout(layoutIndex)"
            >
              <i [ngClass]="layout.getIconClass()"></i>
            </button>
          </div>
        </div>
        <div class="row mb-3" *ngIf="message">
          <div class="col-12 text-center">
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
              <span translate>{{ message }}</span>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="message = null">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ng-template libCustomHost></ng-template>
            <p *ngIf="filteredItems && filteredItems.length === 0" class="nothing-found">
              <span [innerHTML]="getNothingFoundTranslateTag() | translate"></span>
            </p>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <button
            [ngClass]="getLoadMoreCss()"
            *ngIf="!!filteredItems && filteredItems.length > limit"
            class="btn"
            (click)="loadMore()"
          >
            <span translate [translateParams]="{ limit: limit, total: filteredItems.length, batchSize: batchSize }"
              >LOAD_MORE</span
            >
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="filteredItems && filteredItems.length > 0 && renderFilters && renderFilters.length > 0">
      <a
        [ngClass]="{ 'hide-filter-toggle': getGungFilterClasses().open }"
        class="gung-filters-toggle"
        (click)="toggleFilters()"
      >
        <i class="fa fa-filter"></i>
      </a>

      <a
        [ngClass]="{ 'hide-filter-toggle': !getGungFilterClasses().open }"
        class="gung-filters-toggle close-filters"
        (click)="toggleFilters()"
      >
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>
</ng-template>
<!-- upFilter -->
<ng-template #upFilter>
  <div class="row" [hidden]="loading && (!filteredItems || filteredItems.length <= 0)" [ngStyle]="containerStyles">
    <div class="col-12">
      <div class="row" [ngClass]="getSearchGroupCss()">
        <div class="mb-2 col-md col-12 mt-4">
          <div class="search-title" *ngIf="currentAssortment">{{ currentAssortment.name }}</div>
          <!-- <lib-filter-list-search (searchUpdated)="setSearch($event)"></lib-filter-list-search> -->
          <lib-filter-list-search (searchUpdated)="setSearch($event)" [initSearchTerm]="searchTerm">
          </lib-filter-list-search>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <lib-selected-filter
            [topFilter]="true"
            [renderFilters]="renderFiltersForSelected"
            (deselectAll)="clearSelection()"
            (deselectValue)="setSelection($event.filterName, $event.valueId, false)"
            (deselectValueRange)="setSelection($event.filterName, null, false, $event.valueIdRange)"
          >
          </lib-selected-filter>
        </div>
      </div>

      <div class="filter-info mt-5">
        <h3 translate>FILTER_SEARCH</h3>
      </div>
      <div class="row no-gutters">
        <div
          #gungFilters
          *ngFor="let renderFilter of renderFilters"
          [ngClass]="getGungFilterClasses()"
          [class]="getFilterGroupCss()"
          class="col-3 sticky gung-filters d-flex flex-column"
        >
          <colmec-filter-list-top-filter
            [renderFilter]="renderFilter"
            (selectValue)="setSelection(renderFilter.name, $event, true)"
            (deselectValue)="setSelection(renderFilter.name, $event, false)"
            (selectValueRange)="setSelection(renderFilter.name, null, true, $event)"
          ></colmec-filter-list-top-filter>
        </div>
      </div>
      <div class="layouts">
        <button
          class="btn"
          [class.layout-active]="defaultLayout === layoutIndex"
          *ngFor="let layout of layouts; let layoutIndex = index"
          (click)="changeLayout(layoutIndex)"
        >
          <i [ngClass]="layout.getIconClass()"></i>
        </button>
      </div>

      <div class="row">
        <div class="col-12">
          <ng-template libCustomHost></ng-template>
          <p *ngIf="filteredItems && filteredItems.length === 0" class="nothing-found">
            <span [innerHTML]="getNothingFoundTranslateTag() | translate"></span>
          </p>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <button
          [ngClass]="getLoadMoreCss()"
          *ngIf="!!filteredItems && filteredItems.length > limit"
          class="btn"
          (click)="loadMore()"
        >
          <span translate [translateParams]="{ limit: limit, total: filteredItems.length, batchSize: batchSize }"
            >LOAD_MORE</span
          >
        </button>
      </div>
    </div>
    <div *ngIf="filteredItems && filteredItems.length > 0 && renderFilters && renderFilters.length > 0">
      <a
        [ngClass]="{ 'hide-filter-toggle': getGungFilterClasses().open }"
        class="gung-filters-toggle"
        (click)="toggleFilters()"
      >
        <i class="fa fa-filter"></i>
      </a>

      <a
        [ngClass]="{ 'hide-filter-toggle': !getGungFilterClasses().open }"
        class="gung-filters-toggle close-filters"
        (click)="toggleFilters()"
      >
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>
</ng-template>
